import { MiniUsersResponseInterface } from "../users/users-response.interface";

export interface FinancialsResponseInterface {
  id: string;
  annual_sales_target: number;
  status: FinancialsStatus;
  created_at: string | null;
  updated_at: string | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
}

export enum FinancialsStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
  PENDING = "PENDING",
}